export const version = "strings/5.5.0";
